<script setup>
import { ref, onMounted, onUnmounted, watch, shallowRef } from 'vue'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

const props = defineProps({
  data: {
    type: Object,
    required: false,
    default: () => ({
      labels: ['User 1', 'User 2', 'Others'],
      datasets: [
        {
          data: [68, 18, 14],
          backgroundColor: ['#4285F4', '#34A853', '#FBBC05'],
          hoverOffset: 4
        }
      ]
    })
  }
})

const chartCanvas = ref(null)
const chartInstance = shallowRef(null)

const renderChart = () => {
    if (chartInstance.value) {
        chartInstance.value.destroy()
        chartInstance.value = null
    }
    
    // Custom plugin to draw text in center of donut
    const centerText = {
        id: 'centerText',
        beforeDraw: function(chart) {
            if (chart.config.type !== 'doughnut') return;
            var height = chart.height,
            ctx = chart.ctx;
            
            ctx.save();
            var fontSize = (height / 114).toFixed(2);
            ctx.font = "bold " + fontSize + "em sans-serif";
            ctx.textBaseline = "middle";
            ctx.fillStyle = "#000";
            
            // New Centering Logic using textAlign and chartArea
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            
            // Calculate center based on the drawing area
            const { top, left, bottom, right } = chart.chartArea || {};
             if (top === undefined) return;

            const centerX = (left + right) / 2;
            const centerY = (top + bottom) / 2;
            
            var text = props.data.labels.length;
            var textY = centerY - ((bottom - top) * 0.05); // Move up slightly
            
            ctx.fillText(text, centerX, textY);

            var fontSize2 = (height / 200).toFixed(2);
             ctx.font = fontSize2 + "em sans-serif";
             ctx.fillStyle = "#6b7280";
             var text2 = "Users";
             var textY2 = centerY + ((bottom - top) * 0.08); // Move down
                 
             ctx.fillText(text2, centerX, textY2);
             
            ctx.restore();
        }
    };

    if (chartCanvas.value) {
        chartInstance.value = new Chart(chartCanvas.value, {
            type: 'doughnut',
            data: props.data,
            plugins: [centerText],
            options: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: '75%',
                plugins: {
                    legend: {
                        position: 'right',
                        labels: {
                            usePointStyle: true,
                             pointStyle: 'circle',
                             padding: 20,
                             font: {
                                 size: 13
                             },
                             color: '#6b7280'
                        }
                    },
                     tooltip: {
                         callbacks: {
                             label: function(context) {
                                 return ` ${context.label}: ${context.parsed}%`;
                             }
                         }
                     }
                }
            }
        })
    }
}

watch(() => props.data, () => {
    renderChart()
}, { deep: true })

onMounted(() => {
    renderChart()
})

onUnmounted(() => {
    if (chartInstance.value) {
        chartInstance.value.destroy()
        chartInstance.value = null
    }
})
</script>

<template>
  <div class="chart-wrapper">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<style scoped>
.chart-wrapper {
  height: 100%;
  width: 100%;
  min-height: 200px;
}
</style>
